import type { SuperValidated } from 'sveltekit-superforms';

import { z } from 'zod';

import { validatePhoneNumber } from '@shared/ui/fields/phone-field';

export type PurchaseForm = SuperValidated<typeof purchaseForm>;

const phoneCheck = z.custom<string>((number) => {
  if (!number) return true;

  return typeof number === 'string' && validatePhoneNumber(number);
}, 'Phone is not valid');

export const purchaseForm = z.object({
  name: z.string().min(1, 'Name is required').max(124),
  email: z.string().min(1, 'Email is required').trim().email('The e-mail address entered is invalid.'),
  phone: phoneCheck.default(''),
});
